import React from "react";
import BannerBg from "../../../assets/faqs-banner-bg.png";

function FAQsBannerSection({ faq_banner }) {
  const defaultTitle = "Frequently Asked Questions";
  const defaultImage = BannerBg;

  // Extracted from API or fallback
  const title = faq_banner?.banner_title || defaultTitle;
  const bannerimage = faq_banner?.banner_img || defaultImage;

  return (
    <>
      <section
        className="py-10 lg:py-20"
        style={{
          backgroundImage: `url(${bannerimage})`,
        }}
      >
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap items-center -mx-4">
            <div className="w-full max-w-full px-4 text-center">
              <h3 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2]">
                {title}
              </h3>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FAQsBannerSection;
